import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'web-ui-components/lib/molecules/nbas';
import pageContent, { contentPropTypes } from '../../../containers/backEndErrors.content';
import withContent from '../../../containers/withContent';

const AddPayeeFormErrors = ({ errorCode, resetAddPayeeFormErrors, content }) => (
	<Alert iconType="CrossSolidLarge" type="warning" onClose={resetAddPayeeFormErrors}>
		{content[errorCode]}
	</Alert>
);
AddPayeeFormErrors.propTypes = {
	errorCode: PropTypes.string.isRequired,
	resetAddPayeeFormErrors: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
};
export { AddPayeeFormErrors };
export default withContent({ content: pageContent })(AddPayeeFormErrors);
